import { useEffect, useState } from "react";
import { LinkThreeData } from "../../../../types";
import linksthree from "../../../../services/linksthree";
import { toast } from "react-toastify";

interface UseWizardProfileProps {
  userId: number | undefined;
  isOpen: boolean;
}

export const useWizardProfile = ({ userId, isOpen }: UseWizardProfileProps) => {
  const [profileData, setProfileData] = useState<LinkThreeData | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (!userId || !isOpen || profileData) return;

    const loadProfile = async () => {
      try {
        const result = await linksthree.getButtons(userId);
        setProfileData(result);
      } catch {
        toast.error("Erro ao carregar dados do perfil.");
      }
    };

    loadProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isOpen]);

  return {
    profileData,
    setProfileData,
    isProcessing,
    setIsProcessing,
  };
};
